import { IStatisticsConfig } from './typings';

const config: IStatisticsConfig = {
  cols: 3,
  showLine: true,
};

export default config;
